import { ZoomTransformation } from '../../common/zoom/models/zoom-model';

export class CanvasContext {
  private context;
  private canvas: HTMLCanvasElement;

  constructor(private readonly size: { width: number; height: number }, private readonly canvasId: string) {
    this.initialize();
  }

  private initialize() {
    this.setCanvas();
    this.setContext();
  }

  private setCanvas() {
    this.canvas = document.getElementById(this.canvasId) as HTMLCanvasElement;

    this.canvas.width = this.size.width * this.getDpi();
    this.canvas.height = this.size.height * this.getDpi();
    this.canvas.style.width = this.size.width + 'px';
  }

  private setContext() {
    this.context = this.canvas.getContext('2d');
    this.context.scale(this.getDpi(), this.getDpi());
  }

  /**
   * PUBLIC
   */
  public getContext() {
    return this.context;
  }
  public getDpi() {
    return window.devicePixelRatio || 1;
  }
  public startRender(zoom: ZoomTransformation) {
    this.context.save();
    this.context.clearRect(0, 0, this.size.width * this.getDpi(), this.size.height * this.getDpi());
    this.context.translate(zoom.x, zoom.y);
    this.context.scale(zoom.k, zoom.k);
  }
  public endRender() {
    this.context.restore();
  }
}
